import React from 'react';
import { withSize } from 'react-sizeme';
import d3 from '~/core/scripts/chart-components/d3';
import classnames from 'classnames';

import { sortByKey, numberFormat } from '~/core/scripts/utils';
import ChartWrapper from '~/core/scripts/chart-components/ChartWrapper';
import { is768Query, is960Query, is1200Query } from '~/core/scripts/mediaquery-helper';

const parseData = d => {
  const avg = +d.CO2_Segment_Entwicklung;
  const overall = +d.CO2_gesamt_Entwicklung;

  return {
    Jahr: +d.Jahr,
    CO2: overall,
    CO2_Schnitt: avg,
    area: overall > 0 ? overall : avg,
    area0: 0,
    CO2_Segment_Entwicklung: +d.CO2_Segment_Entwicklung,
    CO2_gesamt_Entwicklung: +d.CO2_gesamt_Entwicklung,
    delta: d.delta
  };
};

const getResizeFactor = () => {
  if (is1200Query()) {
    return 4;
  } else if (is960Query()) {
    return 4.5;
  } else if (is768Query()) {
    return 3.125;
  }

  return 3.4375;
};

const margin = { left: 0, top: 1, right: 0, bottom: 0 };
const overallColor = '#444';
const avgColor = '#7b7e9a';

export default withSize()(({ label, data, size, isOverall = false, id }) => {
  const parsedData = data.map(parseData).sort(sortByKey('Jahr', false));
  let { width } = size;
  width -= 20;
  const heightSmall = width * 0.75;
  const factor = getResizeFactor();
  const height = isOverall ? heightSmall * factor : heightSmall;
  const globalYMax = is1200Query() ? 140 : 160;

  const years = parsedData.map(d => d.Jahr);
  const yearsExtent = d3.extent(years);
  const xScale = d3
    .scaleLinear()
    .domain([yearsExtent[0], yearsExtent[yearsExtent.length - 1]])
    .range([margin.left, width - margin.right]);

  const useGlobalYRange = !isOverall;
  const globalYRange = [0, globalYMax];
  //const co2Max = d3.max(parsedData, d => d.CO2_gesamt_Entwicklung);
  const customRange = [0, globalYMax * factor];
  const yScale = d3
    .scaleLinear()
    .domain(useGlobalYRange ? globalYRange : customRange)
    .range([height - margin.bottom, margin.top]);

  const lineCo2 = d3
    .line()
    .x(d => xScale(d.Jahr))
    .y(d => yScale(d.CO2));

  const lineCo2Avg = d3
    .line()
    .x(d => xScale(d.Jahr))
    .y(d => yScale(d.CO2_Schnitt));

  const area = d3
    .area()
    .x(d => xScale(d.Jahr))
    .y1(d => yScale(d.area))
    .y0(d => yScale(d.area0));

  const delta = parsedData.reduce((res, item) => {
    return item.delta;
  }, 0);
  const isAbove = delta > 0;
  const deltaSign = isAbove ? '+' : null;
  const avgRectHeight = yScale(parsedData[0].CO2_Schnitt);
  const subTitleClasses = classnames('linechart__subtitle', { 'is-above': isAbove });
  const showYMaxValue = isOverall || id === 'SUV_GELAENDEWAGEN';
  const yMaxValue = isOverall ? globalYMax * factor : globalYMax;

  return (
    <div className="linechart">
      <div className="linechart__meta">
        <div className="linechart__title">{label}</div>
        <div className={subTitleClasses}>
          {deltaSign}
          {numberFormat(delta, 1)} % CO<sub>2</sub>
        </div>
      </div>
      <div className="linechart__outer">
        {showYMaxValue && <div className="linechart__ymax">{yMaxValue} t</div>}
        {isOverall && (
          <div style={{ top: `${yScale(parsedData[0].CO2_Schnitt)}px` }} className="linechart__comparison">
            Vergleich 2010
          </div>
        )}
        <ChartWrapper width={width} height={height}>
          <path className="area" d={area(parsedData)} />
          <rect
            fill="#ffffff"
            fillOpacity={0.25}
            width={width - margin.right}
            height={height - avgRectHeight}
            x={margin.left}
            y={avgRectHeight}
          />
          <path className="line overall" stroke={overallColor} d={lineCo2(parsedData)} />
          <path className="line avg" stroke={avgColor} d={lineCo2Avg(parsedData)} />
        </ChartWrapper>
        {isOverall && (
          <div className="linechart__xaxis">
            <div>2010</div>
            <div>2018</div>
          </div>
        )}
      </div>
    </div>
  );
});
